export default __webpack_public_path__ + "static/media/switch-app.7fdd5fca.svg";